import React from "react";
import { graphql } from "gatsby";
import {
  Features as FeaturesComponent,
  FeaturesDisplayOptions,
} from "@zempler/theme/src/components/features/Features";

export const Features = ({ data, ...rest }) => {
  // Sort the display value

  function convertDisplay(input: string): FeaturesDisplayOptions {
    if (input === "Featured on right") {
      return "featuredOnRight";
    } else if (input === "Featured on left") {
      return "featuredOnLeft";
    } else if (input === "3 Columns") {
      return "threeColumns";
    }  else {
      throw new Error(
        'Invalid input. Please provide either "Featured on right" or "Featured on left".'
      );
    }
  }

  // Sort the card items

  const features = data.featureItems?.map((item) => {
    return {
      feature: {
        heading: item?.customHeading || item.feature?.heading,
        subHeading: item?.customSubHeading || item.feature?.subHeading,
        link: item?.customLink || item.feature?.featureLink,
        image:
          item.customImage?.image?.localFile ||
          item.feature?.featureImage?.image.localFile,
      },
      backgroundColour: item?.backgroundColour,
      overrideImage: item?.overrideImage?.image?.localFile,
    };
  });

  return (
    <>
      <FeaturesComponent
        features={features}
        display={convertDisplay(data.display)}
      />
    </>
  );
};

export const FeaturesQuery = graphql`
  fragment Features on UMBRACO_FeaturesComponentType {
    display
    featureItems {
      customHeading
      customSubHeading
      backgroundColour
      customLink {
        ...Link
      }
      customImage {
        image {
          ...FeatureImage
        }
      }
      overrideImage {
        image {
          ...OverrideFeatureImage
        }
      }
      feature {
        heading
        subHeading
        featureLink {
          ...Link
        }
        featureImage {
          image {
            ...FeatureImage
          }
        }
      }
      
    }
  }
`;
